import React from "react";
import CTRTwitter from "./CTRTwitter";
import CTRGeneral from "./CTRGeneral";

const CTRBox = ({ metricValue, channel }) => {
  const isTwitter = channel === "twitter";

  return (
    <>
      {isTwitter ? (
        <CTRTwitter metricValue={metricValue} />
      ) : (
        <CTRGeneral metricValue={metricValue} />
      )}
    </>
  );
};

export default CTRBox;
